import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceService {
  private readonly isAppMobile = /anotaaibot/i.test(navigator.userAgent);
  private readonly isAnotaDesktop = /AnotaAIResponde/i.test(navigator.userAgent);
  private readonly isNewFlutterAppMobile = /anotaaimobileapp/i.test(navigator.userAgent);

  public getDevice(): string {
    if (this.isAppMobile) {
      return 'anota_ai_mobile';
    } else if (this.isNewFlutterAppMobile) {
      return 'anota_ai_flutter_mobile';
    } else if (this.isAnotaDesktop) {
      return 'anota_ai_desktop';
    } else {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return 'browser_mobile';
      } else {
        return 'browser_desktop';
      }
    }
  }
}

